import type { EligiblePackageNotificationDTO } from "../../domain/contracts/triggers";
import { buildNotificationMessage } from "../../domain/services/build-notification-message";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@devhop/ui";

export function NotificationPreviewModal({
  open,
  onOpenChange,
  items,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  items: EligiblePackageNotificationDTO[];
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>ຕົວຢ່າງຂໍ້ຄວາມ ({items.length})</DialogTitle>
        </DialogHeader>
        <div className="max-h-[60vh] space-y-4 overflow-y-auto">
          {items.map((item) => {
            const message = buildNotificationMessage({
              studentName: item.studentName,
              packageName: item.packageName,
              packageType: item.packageType,
              triggerType: item.triggerType,
              remainingSessions: item.remainingSessions,
              remainingHours: item.remainingHours,
              expireDate: item.expireDate,
              daysUntilExpiry: item.daysUntilExpiry,
            });
            return (
              <div
                key={`${item.studentId}:${item.packageId}`}
                className="rounded-md border bg-muted/30 p-3"
              >
                <div className="mb-2 font-medium text-sm">
                  {item.studentName} — {item.packageName}
                </div>
                <pre className="whitespace-pre-wrap font-sans text-sm">
                  {message}
                </pre>
              </div>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
